// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"horizontal-scroll_scrollWrapper__ZRUY2","scroll":"horizontal-scroll_scroll__9nRVY"};